// extracted by mini-css-extract-plugin
export default {"icon":"IntegrationCard_icon__W6hJe"};